<div class="profile-sidebar">
	<div class="widget-profile pro-widget-content">
		<div class="profile-info-widget">
			<a href="javascript:void(0)" class="booking-doc-img border-r-12">
				<img class="border-less" [src]="app.getUserImage(patient?.picture)" alt="User Image">
			</a>
			<div class="profile-det-info">
				<h3 class="blue-text">{{patient?.name}}</h3>
				<div class="patient-details">
					<h5><i class="fa fa-birthday-cake"></i> {{patient?.birthDate | date :'MMM d, y'}}, {{patient?.age}}
						years</h5>
					<!-- <h5 class="mb-0"><i class="fa fa-map-marker-alt"></i> Newyork, USA</h5> -->
				</div>
			</div>
		</div>
	</div>
	<div class="dashboard-widget">
		<nav class="dashboard-menu">
			<div class="my-3 mx-2 d-flex justify-content-between">
				<span class="textDivider">
					{{ 'social.users' | translate }} : {{ app?.allHCPs?.length }}
				</span>

				<!-- <span class="textDivider">
					{{ app?.allHCPs?.length }}
				</span> -->
			</div>

			<ul>

				<li *ngIf="app?.allHCPs?.length > 8">
					<!-- <div class="classic-p">
						{{ 'social.seeMore' | translate }}
					</div> -->

					<!-- SpecialityArabic-->
					<mat-form-field class="px-4 w-100" appearance="outline" fxFlex="auto" [dir]="this.app.getUserDire()">
						<mat-label>{{ 'social.searchByName' | translate }}</mat-label>
						<input autocomplete="off" type="text" matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()">
					</mat-form-field>


				</li>


				<li *ngFor="let hcp of app?.HcpsAuth">
					<div class="classic-p" [ngClass]="{'classic-pSelected': hcp?.id == app?.getSelectedHcpForCont()}" (click)="app?.setCont(hcp)">
						<img loading="lazy" class="avatar-img rounded-circle img-profile-user"
						[src]="app.getUserImage(hcp?.picture)" alt="User Image" />

						<span class="userName mx-1">{{hcp?.fullName | splitStringToArEn}}</span>
					</div>
				</li>

				<li *ngIf="app?.allHCPs?.length > app?.HcpsAuth?.length" (click)="app?.paginatorContribute(app?.pageNumber + 1)">
					<div class="classic-p">
						{{ 'social.seeMore' | translate }}
					</div>
				</li>


				<!-- <li routerLinkActive="active">
					<a [routerLink]="'/' + app?.languageCode +'/patients/settings'">
						<i class="fa fa-cog"></i>
						<span>{{ 'Patient.ProfileSettings' | translate }}</span>
					</a>
				</li> -->

				<li routerLinkActive="active" class="hoverSideMenu">
					<a (click)="app?.mainLogOut()" style="cursor: pointer;">
						<i class="fa fa-sign-out "></i>
						<span>{{ 'Patient.Logout' | translate }}</span>
					</a>
				</li>
			</ul>
		</nav>
	</div>
</div>